import Vue from 'vue'
import PortalVue from 'portal-vue'
import './plugins/vuetify'
import './plugins/kendo'
import App from './App.vue'
import router from './router'
import store from './store'
import './services/token-verification'
import './services/error-handling'
import './registerServiceWorker'
import './assets/finstar.css'

Vue.use(PortalVue)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
